<template>
  <div class="text-wrapper">
    <div class="text">{{ text }}</div>
    <Button form="underline" easysize>{{ underlineText }}</Button>
    <div class="easysize_placeholder"></div>
  </div>
</template>

<script>
import Button from "@/components/ButtonV2.vue";
export default {
  name: "Easysize",
  components: {
    Button,
  },
  props: {
    text: {
      type: String,
      default: "Unsure of your size?",
    },
    underlineText: {
      type: String,
      default: "Find your size",
    },
  },
};
</script>

<style lang="scss" scoped>
.text-wrapper {
  display: flex;
  gap: 10px;
  align-items: center;
}
.text {
  @include utility-label(12px);
}

.button {
  font-size: 12px;
}
</style>
